import {
  div,
  h1,
  input,
  button,
  img,
  fnstate,
  span,
  p,
  form
} from '@srfnstack/fntags'
import { user } from '../state.js'

export const Signup = () => {
  const username = fnstate('')
  const email = fnstate('')
  const tenantName = fnstate('')
  const password = fnstate('')
  const confirmPassword = fnstate('')
  const selectedPlan = fnstate('starter') // 'starter', 'pro', 'enterprise'
  const step = fnstate(1) // 1: User Info, 2: Plan Selection
  const error = fnstate('')
  const loading = fnstate(false)

  const handleNext = (e) => {
    e.preventDefault()
    error('')
    if (!username() || !email() || !tenantName() || !password()) {
      error('All fields are required')
      return
    }
    if (password() !== confirmPassword()) {
      error('Passwords do not match')
      return
    }
    step(2)
  }

  const handleSignup = async () => {
    loading(true)
    try {
      const res = await fetch('/api/auth/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: username(),
          email: email(),
          tenantName: tenantName(),
          password: password(),
          plan: selectedPlan()
        })
      })

      const result = await res.json()
      if (res.ok) {
        user({ loggedIn: true, ...result.user })
      } else {
        error(result.error || 'Signup failed')
        step(1)
      }
    } catch (err) {
      error('Network error')
      step(1)
    } finally {
      loading(false)
    }
  }

  const PlanCard = (id, name, price, credits, features) => div({
    class: selectedPlan.bindAttr(p => `card bg-base-200 border-2 cursor-pointer transition-all hover:border-primary ${p === id ? 'border-primary ring-2 ring-primary/20' : 'border-transparent'}`),
    onclick: () => selectedPlan(id)
  },
  div({ class: 'card-body p-4' },
    h1({ class: 'text-lg font-bold' }, name),
    div({ class: 'text-2xl font-black' }, price, span({ class: 'text-xs font-normal opacity-50' }, '/mo')),
    div({ class: 'badge badge-primary badge-sm' }, `${credits} Credits`),
    div({ class: 'mt-2 text-xs space-y-1' },
      features.map(f => div({ class: 'flex items-center gap-1' }, span({ class: 'text-success' }, '✓'), f))
    )
  )
  )

  return div({ class: 'min-h-screen flex items-center justify-center bg-base-300 p-4' },
    div({ class: 'card bg-base-100 shadow-2xl w-full max-w-md overflow-hidden border border-base-300' },
      div({ style: 'background-color: #282f3f', class: 'p-8 flex justify-center' },
        img({ src: '/images/etherbuildr_logo.png', alt: 'EtherBuildr', style: 'height: 60px;' })
      ),
      div({ class: 'p-8 space-y-4' },
        step.bindAs(s => s === 1
          ? form({ onsubmit: handleNext, class: 'space-y-4' },
            h1({ class: 'text-xl font-bold text-center mb-4' }, 'CREATE ACCOUNT'),
            error.bindAs(err => err ? div({ class: 'alert alert-error text-xs p-2' }, span(err)) : ''),
            div({ class: 'form-control' },
              input({
                type: 'text',
                placeholder: 'Username',
                class: 'input input-bordered w-full',
                value: username.bindAttr(),
                oninput: (e) => username(e.target.value)
              })
            ),
            div({ class: 'form-control' },
              input({
                type: 'email',
                placeholder: 'Email',
                class: 'input input-bordered w-full',
                value: email.bindAttr(),
                oninput: (e) => email(e.target.value)
              })
            ),
            div({ class: 'form-control' },
              input({
                type: 'text',
                placeholder: 'Your Shop Name',
                class: 'input input-bordered w-full',
                value: tenantName.bindAttr(),
                oninput: (e) => tenantName(e.target.value)
              })
            ),
            div({ class: 'form-control' },
              input({
                type: 'password',
                placeholder: 'Password',
                class: 'input input-bordered w-full',
                value: password.bindAttr(),
                oninput: (e) => password(e.target.value)
              })
            ),
            div({ class: 'form-control' },
              input({
                type: 'password',
                placeholder: 'Confirm Password',
                class: 'input input-bordered w-full',
                value: confirmPassword.bindAttr(),
                oninput: (e) => confirmPassword(e.target.value)
              })
            ),
            button({
              class: 'btn btn-primary w-full',
              type: 'submit'
            }, 'Select Plan →'),
            p({ class: 'text-center text-xs mt-4' },
              'Already have an account? ',
              button({
                class: 'link link-primary',
                type: 'button',
                onclick: () => user.assign({ showSignup: false })
              }, 'Login')
            )
          )
          : form({ onsubmit: (e) => { e.preventDefault(); handleSignup() }, class: 'space-y-4' },
            h1({ class: 'text-xl font-bold text-center mb-4' }, 'SELECT YOUR PLAN'),
            div({ class: 'grid grid-cols-1 gap-4' },
              PlanCard('starter', 'Starter', '$29', 100, ['Full Steel Thread Access', 'Community Support']),
              PlanCard('pro', 'Pro', '$99', 500, ['Faster GPU Access', 'Batch Upscaling', 'Priority Support']),
              PlanCard('enterprise', 'Enterprise', '$299', 2000, ['Dedicated GPU Cluster', 'Custom AI Models', 'API Access'])
            ),
            button({
              class: 'btn btn-primary w-full mt-4',
              type: 'submit',
              disabled: loading.bindAttr()
            }, loading.bindAs(l => l ? span({ class: 'loading loading-spinner' }) : 'Complete Registration')),
            button({
              class: 'btn btn-ghost btn-sm w-full',
              type: 'button',
              onclick: () => step(1)
            }, '← Back')
          ))
      )
    )
  )
}
